import { useController, useFormContext } from "react-hook-form"
import { useIntl } from "react-intl"
import { formMessages } from "src/common/form.messages"
import { containsLink } from "../newsContent"
import { NewsContentEditor } from "./NewsContentEditor"
import { newsEditorMessages as messages } from "./newsEditor.messages"

interface NewsContentFieldProps {
	disabledHint?: string
	name: string
}

export const NewsContentField = ({ disabledHint, name }: NewsContentFieldProps) => {
	const { control } = useFormContext()
	const { formatMessage } = useIntl()
	const {
		field: { onBlur, onChange, value },
		fieldState: { error },
	} = useController({
		control,
		name,
		rules: {
			validate: {
				noLinks: (content: string) => !containsLink(content) || formatMessage(messages.contentContainsLink),
				required: (content: string) => !!content?.trim() || formatMessage(formMessages.required),
			},
		},
	})

	return (
		<NewsContentEditor
			description={formatMessage(messages.sourceLanguage)}
			disabledHint={disabledHint}
			errorMessage={error?.message}
			label={formatMessage(messages.content)}
			required
			value={value ?? ""}
			onBlur={onBlur}
			onChange={onChange}
		/>
	)
}
